import { render } from "./SaveApplication.vue?vue&type=template&id=f6074cf6&scoped=true"
import script from "./SaveApplication.vue?vue&type=script&lang=js"
export * from "./SaveApplication.vue?vue&type=script&lang=js"

import "./SaveApplication.vue?vue&type=style&index=0&id=f6074cf6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6074cf6"]])

export default __exports__